import { auth } from '@/services/firebase.service';
import { getPreferredLocale } from '@/services/locale.service';

async function _waitUntilUserIsLoaded() {
  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged(()=>{
      unsubscribe();
      resolve();
    });
  });
}

function _request(method) {
  return async (url, options={}) => {
    await _waitUntilUserIsLoaded();

    if (options.injectToken && !auth.currentUser) {
      return {
        response: {
          ok: false,
          status: 401,
          statusText: 'Unauthorized',
        },
        data: {
          error_type: 'UNAUTHORIZED',
          error_message: 'No token was provided. Remember to include the token in the Authorization header.',
          error_data: {},
        },
      };
    }

    let fetchOptions = {
      method,
      headers: {
        'Accept-Language': getPreferredLocale()
      }
    };

    if(options.credentials || options.includeCredentials) {
      fetchOptions = {
        ...fetchOptions,
        credentials: options.credentials || 'include'
      };
    }

    if((options.injectToken || options.optionalToken) && Boolean(auth.currentUser)) {
      const accessToken = await auth.currentUser.getIdToken();

      fetchOptions = {
        ...fetchOptions, 
        headers: {
          ...fetchOptions.headers, 
          'Authorization': `Bearer ${accessToken}`
        }
      };
    }

    if(options.headers) {
      fetchOptions = {
        ...fetchOptions, 
        headers: {
          ...fetchOptions.headers, 
          ...options.headers
        }
      };
    }

    if(options.contentType !== false && (!options.contentType || options.contentType === "json")) {
      fetchOptions = {
        ...fetchOptions, 
        headers: {
          ...fetchOptions.headers, 
          'Content-Type': 'application/json', 
          'Accept': '*/*'
        }, 
        body: JSON.stringify(options.body)
      };
    } 

    return new Promise((resolve, reject) => {
      fetch(url, fetchOptions)
        .then(async response => {
          let data = null;
          // only parse JSON if the server actually sent JSON
          const contentType = response.headers.get('content-type') || '';
          if (contentType.includes('application/json')) {
            try {
              data = await response.json();
            } catch (err) {
            // empty or malformed JSON: swallow error, leave data=null
              console.warn('fetchWrapper: JSON parse failed', err);
            }
          }
          resolve({ response, data });
        })
        .catch(error => reject(error));
    });
  };
}

const fetchWrapper = {
  get: _request('GET'),
  post: _request('POST'),
  put: _request('PUT'),
  delete: _request('DELETE')
};

export default fetchWrapper; 
